import { MotionDiv } from '@/components/element/MotionDiv';
import { FixedAssets } from '@/components/features/tasks/payment/ToDoList/FixedAssets';
import { InvoiceCheck } from '@/components/features/tasks/payment/ToDoList/InvoiceCheck';
import { PaymentAmount } from '@/components/features/tasks/payment/ToDoList/PaymentAmount';
import { PaymentTaskExpenseAccountItems } from '@/components/features/tasks/payment/ToDoList/PaymentTaskExpenseAccountItems';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { useEffect, useState } from 'react';
import { AccountingConfirmationCheck } from '@/components/features/tasks/payment/ToDoList/AccountingConfirmationCheck';
import { OrderAllocatedExpenses } from '@/components/features/tasks/payment/ToDoList/OrderAllocatedExpenses';

export const ToDoList = () => {
  const { paymentTask: task } = useCurrentPaymentTask();
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    if (task) {
      setDisabled(!['accepted', 'confirming'].includes(task!.payment_task_phase.name));
    }
  }, [task]);

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header">
        <h6 className="mb-1">TODOリスト</h6>
        <p className="text-xs mb-0">TODOを処理して、タスクを次のフェーズへ移動させてください。</p>
      </div>
      <div className="card-body pt-0">
        <ul className="list-group list-group-flush" data-toggle="checklist">
          <li className="list-group-item border-0 flex-column align-items-start ps-0 py-0 mb-3">
            <PaymentAmount disabled={disabled} />
            <hr className="horizontal dark mt-4 mb-0" />
          </li>
          {task!.accounting_manual_mode && (
            <li className="list-group-item border-0 flex-column align-items-start ps-0 py-0 mb-3">
              <AccountingConfirmationCheck disabled={disabled} />
              <hr className="horizontal dark mt-4 mb-0" />
            </li>
          )}
          <li className="list-group-item border-0 flex-column align-items-start ps-0 py-0 mb-3">
            <InvoiceCheck disabled={disabled} />
            <hr className="horizontal dark mt-4 mb-0" />
          </li>
          <li className="list-group-item border-0 flex-column align-items-start ps-0 py-0 mb-3">
            <PaymentTaskExpenseAccountItems disabled={disabled} />
          </li>
          <li className="list-group-item border-0 flex-column align-items-start ps-0 py-0 mb-3">
            <FixedAssets disabled={disabled} />
          </li>
          <OrderAllocatedExpenses disabled={disabled} />
        </ul>
      </div>
    </MotionDiv>
  );
};
